var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMouseClic(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 34,
    viewBox: "0 0 22 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #d6d6d6;\r\n      }\r\n\r\n      .cls-3, .cls-4 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-3 {\r\n        stroke: #707070;\r\n      }\r\n\r\n      .cls-5 {\r\n        fill: #707070;\r\n      }\r\n\r\n      .cls-6 {\r\n        stroke: none;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3504",
    "data-name": "Group 3504",
    transform: "translate(21929.785 19812)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1889",
    "data-name": "Rectangle 1889",
    className: "cls-1",
    width: 22,
    height: 34,
    rx: 11,
    transform: "translate(-21929.785 -19812)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1890",
    "data-name": "Rectangle 1890",
    className: "cls-2",
    d: "M10,0h1a0,0,0,0,1,0,0V15a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V10A10,10,0,0,1,10,0Z",
    transform: "translate(-21929.785 -19810.9)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3503",
    "data-name": "Group 3503",
    transform: "translate(-8491.785 533)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1884",
    "data-name": "Rectangle 1884",
    className: "cls-3",
    transform: "translate(-13438 -20345)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    width: 22,
    height: 34,
    rx: 11
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 0.5,
    y: 0.5,
    width: 21,
    height: 33,
    rx: 10.5
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1887",
    "data-name": "Rectangle 1887",
    className: "cls-4",
    width: 4,
    height: 8,
    rx: 2,
    transform: "translate(-13429 -20338)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1891",
    "data-name": "Rectangle 1891",
    className: "cls-5",
    width: 4,
    height: 8,
    rx: 2,
    transform: "translate(-21920.785 -19803.9)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMouseClic);
export default __webpack_public_path__ + "static/media/Mouse_clic.9418a4cbc14b251e0cb0346ee0d776fb.svg";
export { ForwardRef as ReactComponent };